module.exports = __webpack_public_path__ + "img/home_bnaner3.7da31e86.jpg";